<div class="page-chat content-layout" fxLayout="column">

    <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column">

        <calsoft-breadcrumbs [url]="'product,Product Import'"
            [url]="productImport?'product,Product Import':'product,Product Import'"
            [currentPage]="productImport?'Product,Product Import':'Product, Product Export'" [header]="'primary'">
        </calsoft-breadcrumbs>
        <div fxLayout="column" fxLayoutGap="24px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <button [attr.guide]="'products-import-btn-1' + '__' + sanitizedUrl" (click)="back()" matTooltip="Back" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            {{title}}
                        </div>
                    </div>

                    
                    <div *ngIf="!productImport" class="editSets" [formGroup]="firstFormGroup">
                        <div class="products-padding">
                            <div class="editSets">

                                <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                    <span>Export Excel
                                    </span>
                                </div>
                                <div class="products-padding">
                                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                                      

                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Attribute Set</mat-label>
                                            <mat-select  formControlName="attributeSet"
                                                [disableOptionCentering]="true"  required #singleSelect>
                                                <mat-option>
                                                    <ngx-mat-select-search name="Attribute Search"
                                                        ngDefaultControl [formControl]="attributeFilterControl"
                                                        placeholderLabel="Attribute Search"
                                                        [preventHomeEndKeyPropagation]="true"
                                                        noEntriesFoundLabel="No data found">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                <mat-option
                                                    *ngFor="let item of filteredAttributeList; let i=index;"
                                                    [value]="item.attributeSetId">
                                                    {{item.attributeSetName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngFor="let validation of createAttributeValidations.attributeSet">
                                                <mat-error class="error-message"
                                                    *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                    {{validation.message}}
                                                </mat-error>
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Product Type</mat-label>
                                            <mat-select required  [disableOptionCentering]="true" formControlName="type">
                                                <mat-option *ngFor="let item of productType" [value]="item">
                                                    {{item}}
                                                </mat-option>
                                            </mat-select>

                                            <mat-error *ngFor="let validation of createAttributeValidations.type">
                                                <mat-error class="error-message"
                                                    *ngIf="firstFormGroup.get('type').hasError(validation.type) && (firstFormGroup.get('type').dirty || firstFormGroup.get('type').touched) ">
                                                    {{validation.message}}
                                                </mat-error>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="btn" fxLayoutAlign="end center">
                                    <button [attr.guide]="'products-import-btn-2' + '__' + sanitizedUrl" [disabled]="textAdd !='Download Template'" (click)="getExcelTemplate()"
                                        mat-raised-button>
                                        {{textAdd}}
                                        <mat-icon *ngIf="textAdd !='Download Template' ">
                                            <mat-spinner color="primary" diameter="20">
                                            </mat-spinner>
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="productImport" class="padding-10" fxLayout="column" fxLayoutGap="10px">
                        <div class="editSets" [formGroup]="firstFormGroup">
                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                <span>Product Excel

                                </span>
                            </div>
                            <div class="products-padding"  fxLayout="row" fxLayoutAlign="start center">


<!-- Horizontal -->
                                <mat-stepper orientation="{{orientation}}" style="width: 100%;" fxFlex [linear]="isLinear" #stepper>
                                    <mat-step [stepControl]="firstFormGroup">

                                        <ng-template matStepLabel>Select Type of AttributeSet</ng-template>
                                        <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                                            <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Attribute Set</mat-label>
                                                <mat-select  required [disableOptionCentering]="true"
                                                    formControlName="attributeSet">
                                                    <mat-option>
                                                        <ngx-mat-select-search name="Attribute Search"
                                                            ngDefaultControl [formControl]="attributeFilterControl"
                                                            placeholderLabel="Attribute Search"
                                                            [preventHomeEndKeyPropagation]="true"
                                                            noEntriesFoundLabel="No data found">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option
                                                        *ngFor="let item of filteredAttributeList; let i=index;"
                                                        [value]="item.attributeSetId">
                                                        {{item.attributeSetName}}
                                                    </mat-option>
                                                </mat-select>

                                                <mat-error
                                                    *ngFor="let validation of createAttributeValidations.attributeSet">
                                                    <mat-error class="error-message"
                                                        *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                        {{validation.message}}
                                                    </mat-error>
                                                </mat-error>

                                            </mat-form-field>

                                            <mat-form-field fxFlex appearance="outline">
                                                <mat-label>Product Type</mat-label>
                                                <mat-select required [disableOptionCentering]="true" formControlName="type">
                                                    <mat-option *ngFor="let item of productType" [value]="item">
                                                        {{item}}
                                                    </mat-option>
                                                </mat-select>

                                                <mat-error *ngFor="let validation of createAttributeValidations.type">
                                                    <mat-error class="error-message"
                                                        *ngIf="firstFormGroup.get('type').hasError(validation.type) && (firstFormGroup.get('type').dirty || firstFormGroup.get('type').touched) ">
                                                        {{validation.message}}
                                                    </mat-error>
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                      
                                        <div fxLayout.lt-md="column" fxFlex fxLayout.gt-sm="row" fxLayoutGap="10px" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center">
                                           
                                             
                                                <button [attr.guide]="'products-import-btn-3' + '__' + sanitizedUrl" mat-raised-button [disabled]="textAdd !='Download Template'" (click)="getExcelTemplate()"
                                                mat-raised-button>
                                                {{textAdd}}
                                                <mat-icon *ngIf="textAdd !='Download Template' ">
                                                    <mat-spinner color="primary" diameter="20">
                                                    </mat-spinner>
                                                </mat-icon>
                                            </button>

                                            <button [attr.guide]="'products-import-btn-4' + '__' + sanitizedUrl" ngStyle.lt-sm="width: 100%;" mat-raised-button (click)="goToStep2(stepper)" 
                                            color="primary">Next</button>
                                            

                                        </div>

                                    </mat-step>
                                    <mat-step [stepControl]="secondFormGroup" label="Import Excel">
                                        <form [formGroup]="secondFormGroup">



                                           <input [attr.guide]="'products-import-inp-5' + '__' + sanitizedUrl" [autocomplete]="'off'"type="file" #myInput ng2FileSelect [uploader]="uploader"
                                                *ngIf="!excelTemplateUploaded"/>
                                            <div fxLayout="row" class="padding-10" fxLayoutAlign="start center"
                                                fxLayoutGap="5px" *ngIf="!excelTemplateUploaded">

                                                <ng-container *ngIf="uploader?.queue?.length>0">
                                                    <button [attr.guide]="'products-import-btn-6' + '__' + sanitizedUrl" [disabled]="text !='Upload'" (click)="upload()"
                                                        mat-raised-button>
                                                        {{text}}
                                                        <mat-icon *ngIf="text !='Upload' ">
                                                            <mat-spinner color="primary" diameter="20">
                                                            </mat-spinner>
                                                        </mat-icon>
                                                    </button>
                                                </ng-container>
                                            </div>

                                            <!-- <div class="products-padding"  fxLayout="row" *ngIf="excelTemplateUploaded&& successList.length>0">
                                               SuccessList:
                                               <div fxLayout="row">


                                                SuccessList
        
                                                </div>
                                                <table fxFlex   >
                                                    <tr>
                                                        <th>Name</th>
                                                       
                                                    </tr>
                                                    <tr *ngFor="let item of successList ">
                                                        <td>{{item.name}}</td>
                                                       
                                                    </tr>
    
                                                </table>
                                            </div> -->

                                            <div class="products-padding" fxLayout="row" *ngIf="excelTemplateUploaded">
                                                File Uploaded SuccessFully Procced to Next Step
                                            </div>


                                            <div class="products-padding" fxLayout="column"
                                                *ngIf="excelTemplateUploaded && failedList.length>0">
                                                <div fxLayout="row">


                                                    Failure List:

                                                </div>
                                                <div fxLayout="row" >
                                                    <table fxFlex>
                                                        <tr>
                                                            <th>Name</th>

                                                        </tr>
                                                        <tr *ngFor="let item of failedList">
                                                            <td>{{item.name}}</td>

                                                        </tr>

                                                    </table>
                                                </div>
                                            </div>


                                            <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                                <button [attr.guide]="'products-import-btn-7' + '__' + sanitizedUrl" *ngIf="!excelTemplateUploaded" mat-raised-button [disabled]="textAdd !='Download Template'" (click)="getExcelTemplate()"
                                                mat-raised-button>
                                                {{textAdd}}
                                                <mat-icon *ngIf="textAdd !='Download Template' ">
                                                    <mat-spinner color="primary" diameter="20">
                                                    </mat-spinner>
                                                </mat-icon>
                                            </button>
                                                <button [attr.guide]="'products-import-btn-8' + '__' + sanitizedUrl" ngStyle.lt-sm="width: 100%;"  (click)="goBack(stepper)" mat-raised-button>Back</button>
                                                <button [attr.guide]="'products-import-btn-9' + '__' + sanitizedUrl" ngStyle.lt-sm="width: 100%;"  (click)="goToStep3(stepper)" mat-raised-button
                                                    color="primary">Next</button>

                                            </div>
                                        </form>

                                    </mat-step>

                                    <mat-step [stepControl]="thirdFormGroup" label="Upload Image">
                                        <ng-container *ngIf="!zipStatus">
                                            <calsoft-zip-import (onSuccess)="getResult($event)"
                                                [productId]="productIdUploaded"
                                                [id]="firstFormGroup.value.attributeSet">
                                            </calsoft-zip-import>
                                        </ng-container>

                           
                                    <div class="products-padding" fxLayout="column" *ngIf="zipStatus&&zipFailedList.length>0">

                                            <div fxLayout="row">


                                                Failure List:

                                            </div>
                                            <div fxLayout="row">
                                                <table fxFlex>
                                                    <tr>
                                                        <th>Name</th>

                                                    </tr>
                                                    <tr *ngFor="let item of zipFailedList ">
                                                        <td>{{item}}</td>

                                                    </tr>

                                                </table>
                                            </div>
                                    </div>


                                        <div class="products-padding" fxLayout="row" *ngIf="zipStatus">
                                            File Uploaded SuccessFully Procced to Next Step
                                        </div>


                                        <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                            <!-- <button [attr.guide]="'products-import-btn-10' + '__' + sanitizedUrl" (click)="goBack(stepper)" mat-raised-button>Back</button> -->
                                            <button [attr.guide]="'products-import-btn-11' + '__' + sanitizedUrl" ngStyle.lt-sm="width: 100%;" (click)="goForward(stepper)" mat-raised-button
                                                color="primary">Next</button>
                                        </div>
                                    </mat-step>
                                    <mat-step>
                                        <ng-template matStepLabel>Done</ng-template>
                                        <p>You are now done.</p>

                                        <p>Excel Import Completed SuccessFully</p>
                                        <div fxLayout="row" fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                            <!-- <button [attr.guide]="'products-import-btn-12' + '__' + sanitizedUrl" (click)="goBack(stepper)" mat-raised-button>Back</button> -->
                                            <button [attr.guide]="'products-import-btn-13' + '__' + sanitizedUrl" ngStyle.lt-sm="width: 100%;" (click)="goToProductPage()" mat-raised-button
                                                color="primary">Next</button>
                                        </div>
                                    </mat-step>

                                </mat-stepper>



                            </div>
<!-- end -->

                           
                            <!-- end -->
                        </div>





                    </div>
                </div>

            </div>
        </div>
    </div>